<script setup lang="ts">
const { disabled = false, trainingType } = defineProps<{
  disabled?: boolean
  trainingType: "quiz" | "video"
}>()
</script>

<template>
  <Tooltip :disabled>
    <slot />

    <template #content>
      <div class="flex flex-col gap-0.5">
        <TypographyCaption class="text-zinc-200">
          <TypographyStrong>
            {{ $t(`dynamic_keys.training_restrictions.${trainingType}.title`) }}
          </TypographyStrong>
        </TypographyCaption>
        <TypographyCaption class="text-zinc-300">
          {{
            $t(`dynamic_keys.training_restrictions.${trainingType}.description`)
          }}
        </TypographyCaption>
        <div
          class="mt-1.5 mb-1 flex h-min w-min items-center gap-1.5 rounded-xl bg-violet-300/20 px-2 py-0.5 text-nowrap"
        >
          <SvgoPikaCalendarTimer class="size-3 text-violet-200" />
          <TypographyCaption class="text-xxs text-violet-200">
            {{ $t("dynamic_keys.training_restrictions.reset") }}
          </TypographyCaption>
        </div>
      </div>
    </template>
  </Tooltip>
</template>
